import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import type { PaginationResponse } from '@/models/pagination';
import type { Sandbox } from '@/models/sandbox';

export const getSandboxes = async ({ game_code }: { game_code: string }) => {
  const response = await api.get<{ sandboxes: Sandbox[] } & PaginationResponse>(
    `/v1/sandboxes?game_code=${game_code}&sort_by=created_at&sort_order=asc&limit=50`,
  );
  return response.data;
};

export const getSandboxesQueryOptions = ({
  game_code,
}: {
  game_code: string;
}) => {
  return {
    queryKey: ['sandboxes', game_code],
    queryFn: () => getSandboxes({ game_code }),
  };
};
export const useGetSandboxes = ({ game_code }: { game_code: string }) => {
  return useQuery(getSandboxesQueryOptions({ game_code }));
};
